module.exports = __webpack_public_path__ + "static/media/cover_eng_5_6.1da7d80a.jpg";